<template>
  <b-form-radio-group
    v-model="localValue"
    @change="handleChange"
    class="d-inline conbinations-radio"
    id="radio-group"
    name="radio-sub-component"
  >
    <b-form-radio :value="false" >
        <v-tooltip right>
            <template v-slot:activator="{ on, props }">
                <p v-on="on" v-bind="props">おまかせ</p>
            </template>
            <span>おまかせ設定では、公休・夜勤・明番の勤務回数を設定します。<br>それ以外の勤務区分は「⑤配置人数の設定」に対して、自動的に勤務回数が最適な回数で割当されます。</span>
        </v-tooltip>
    </b-form-radio>
    <b-form-radio :value="true">
        <v-tooltip right>
            <template v-slot:activator="{ on, props }">
                <p v-on="on" v-bind="props">こだわり</p>
            </template>
            <span>こだわり設定では、全ての勤務区分の勤務回数を設定します。<br>夜勤や特定の勤務区分の勤務回数が職員ごとに異なる場合に利用します。</span>
        </v-tooltip>
    </b-form-radio>
  </b-form-radio-group>
</template>

<script>
export default {
  name: 'ModeChooseRadio',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  methods: {
    async handleChange(e) {
      // 一度、変更前の値に戻す
      this.localValue = !e;
      
      if (await this.swalConfirmReset()) {
        this.localValue = e;
        this.$emit('input', this.localValue);
      }
    },
    async swalConfirmReset() {
      const { isConfirmed } = await this.$swal({
          html: '現在設定している各勤務区分の勤務回数の設定が<br>すべてリセットされます。よろしいですか？<br>※「はい」を選択後「保存」しなければ、保存は<br>されません',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'はい',
          cancelButtonText: 'いいえ',
          showCloseButton: true,
          customClass: {
              confirmButton: 'btn btn-primary',
              cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
      });

      return isConfirmed;
    }
  },
};
</script>
